var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 278,
    viewBox: "0 0 285 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.577 53.7688C104.085 57.692 106.176 66.1515 102.248 72.6648C100.992 74.7486 99.2702 76.3717 97.3027 77.4992L110.141 104.342C113.126 110.588 120.863 112.883 126.769 109.284L160.334 88.8525C158.17 84.7311 158.152 79.6148 160.736 75.3336C164.664 68.8288 173.12 66.7337 179.633 70.661C186.137 74.5886 188.231 83.0437 184.304 89.5569C182.582 92.4125 179.988 94.4161 177.068 95.4347L187.435 132.007C189.323 138.673 196.557 142.243 202.995 139.687L232.086 128.155C230.958 124.53 231.324 120.461 233.443 116.951C237.371 110.446 245.826 108.351 252.339 112.278C258.843 116.206 260.938 124.661 257.01 131.174C253.209 137.47 245.173 139.632 238.762 136.215L193.164 224.387L63.1301 175.229L87.2695 78.9505C85.9218 78.6327 84.5992 78.1014 83.3522 77.3459C76.8478 73.4182 74.7534 64.9632 78.6812 58.4499C82.6093 51.9452 91.0645 49.85 97.5774 53.7773L97.577 53.7688Z",
    fill: "url(#paint0_linear_31_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9157 171.62C61.5561 161.994 96.2182 166.18 135.336 180.971C174.453 195.762 203.213 215.556 199.572 225.182C195.932 234.808 161.27 230.621 122.153 215.831C83.0351 201.04 54.2753 181.246 57.9157 171.62Z",
    fill: "url(#paint1_linear_31_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6325 177.835C67.569 170.07 98.1473 174.438 132.931 187.59C167.715 200.742 193.532 217.699 190.596 225.463C187.659 233.228 157.081 228.861 122.297 215.709C87.5134 202.557 61.696 185.6 64.6325 177.835Z",
    fill: "url(#paint2_linear_31_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.925 134.207C230.331 129.06 229.968 120.353 235.115 114.759C240.262 109.164 248.969 108.801 254.563 113.948C260.157 119.094 260.519 127.801 255.373 133.396C250.226 138.99 241.519 139.353 235.925 134.207Z",
    fill: "url(#paint3_radial_31_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.168 92.662C157.574 87.5155 157.211 78.8083 162.358 73.2139C167.505 67.6195 176.212 67.2563 181.806 72.4028C187.4 77.5492 187.763 86.2563 182.616 91.8507C177.469 97.4451 168.762 97.8084 163.168 92.662Z",
    fill: "url(#paint4_radial_31_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1463 75.7684C75.5524 70.622 75.1899 61.9148 80.3367 56.3204C85.4835 50.7259 94.1907 50.3628 99.7846 55.5092C105.379 60.6556 105.741 69.3627 100.594 74.9572C95.4474 80.5516 86.7403 80.9148 81.1463 75.7684Z",
    fill: "url(#paint5_radial_31_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.891 142.739L152.497 145.237C154.237 145.895 155.114 147.839 154.456 149.579L149.124 163.678C148.466 165.418 146.522 166.296 144.782 165.638L138.176 163.14C136.436 162.482 135.559 160.538 136.217 158.798L141.549 144.699C142.207 142.959 144.151 142.081 145.891 142.739Z",
    stroke: "white",
    strokeWidth: 5.9798,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.051 199.622L202.803 201.07C203.833 201.92 205.18 201.609 205.817 200.367L213.457 185.437C214.09 184.199 213.773 182.504 212.738 181.65L210.986 180.202C209.957 179.352 208.61 179.663 207.973 180.905L200.333 195.835C199.7 197.073 200.017 198.768 201.051 199.622Z",
    stroke: "white",
    strokeWidth: 4.75166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3763 150.576L74.1149 150.584C75.5728 150.587 77.022 149.464 77.3507 148.069L81.1395 131.889C81.4682 130.494 80.5496 129.355 79.0917 129.352L77.3531 129.344C75.8953 129.341 74.4461 130.464 74.1174 131.859L70.3285 148.039C69.9998 149.434 70.9185 150.573 72.3763 150.576Z",
    stroke: "white",
    strokeWidth: 4.75166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_542",
    x: 52.6049,
    y: 46.7966,
    width: 231.403,
    height: 208.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.305882 0 0 0 0 0.960784 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_542",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_542",
    x1: 233.471,
    y1: 120.002,
    x2: 44.0444,
    y2: 156.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#EF04A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D390F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D092F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9DC3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7DE1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#71EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_542",
    x1: 200.816,
    y1: 202.302,
    x2: 49.5873,
    y2: 194.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FB22A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EA4FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D689EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CEA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#92D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#71EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_542",
    x1: 200.59,
    y1: 173.129,
    x2: 75.1466,
    y2: 222.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#02B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#12A8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D89E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8357C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E2139A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FF008E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_31_542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(18.637 -24.5765 -24.5748 -18.6351 233.568 132.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FB22A3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F629A6",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EC3CB1",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DA5AC2",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C285DA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5BBF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_31_542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.95065 -30.2141 -30.2135 -4.94828 164.697 94.7684)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E560CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E361CF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DF67D2",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D871D5",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CE7EDB",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C18FE2",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B2A4EA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A0BCF4",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#97C9FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_31_542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.7101 -6.31829 -6.31959 16.7107 91.3656 64.8463)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3490E8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3591E8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#3896E9",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D9EEB",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#45AAEE",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4EB9F2",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5ACBF6",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#68E0FB",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#71EDFF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.0886d6f095854959898cad91647c4748.svg";
export { ForwardRef as ReactComponent };